import theme from '../themes/default'

export default {
  wrap: {
    'margin-left': '18px',
    'margin-right': '18px',
    'margin-top': '80px',
    'text-align': 'center',
  },
  icon: {
    '& svg': {
      width: '80px !important',
      height: '80px !important',
    },
  },
  title: {
    color: '#C54545',
    'font-size': '24px',
    'font-weight': 'bold',
    'margin-top': '15px',
    'margin-bottom': '10px',
  },
  subTitle: {
    'font-size': '14px',
    'font-weight': 'bold',
    'letter-spacing': '1px',
  },
  'button-wrap': {
    'margin-top': '30px',
    '& .am-button': {
      'font-size': '14px',
      'letter-spacing': '2px',
      '&:nth-child(2)': {
        'margin-top': '10px',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/Confirmation.js